"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeNode = void 0;
var tslib_1 = require("tslib");
exports.TreeNode = {
    setDerived: function (node, derived) { return (tslib_1.__assign(tslib_1.__assign({}, node), { derived: derived })); },
};
